import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SafetyCommentsRaised from "./projDashWidget/SafetyCommentsRaised";
import AdrStatus from "./projDashWidget/AdrStatus";
import StaffAssignments from "./projDashWidget/StaffAssignments";
import { projWidgetTypes } from "../../../_constants/widgetTypes";
import { DOCTYPE } from "../../../_constants/docTypeConstants";

class ProjDashWidget extends Component {
  handleClick_viewDetails = (widget) => (e) => {
    const { projectId, user } = this.props;
    e.preventDefault();
    switch (widget.widgetType) {
      case projWidgetTypes.SAFETY_COMMENTS_RAISED: {
        const safetyKwId = Object.keys(widget.data)[0];
        const reportParams = {
          projectId,
          reportId: 0,
          createdBy: user.fullName,
          reportType: DOCTYPE.REPORT_COMMENT_KEYWORD,
          label: "Comments by Keyword Report",
          keywordId: safetyKwId || 0,
          searchAllDates: true,
          dateFrom: null,
          dateTo: null,
        };
        widget.viewDetailsAction(reportParams);
        break;
      }
      case projWidgetTypes.ADR_STATUS:
      case projWidgetTypes.STAFF_ASSIGNMENTS:
        widget.viewDetailsAction(projectId);
        break;
      default:
        break;
    }
  };

  renderWidgetContent = () => {
    const { data, widgetType } = this.props.widget;
    switch (widgetType) {
      case projWidgetTypes.SAFETY_COMMENTS_RAISED:
        return <SafetyCommentsRaised data={data} />;
      case projWidgetTypes.ADR_STATUS:
        return <AdrStatus data={data} />;
      case projWidgetTypes.STAFF_ASSIGNMENTS:
        return <StaffAssignments data={data} />;
      default:
        break;
    }
  };
  render() {
    const { widget } = this.props;
    return (
      <div className={"card h-100 dash-min-height overflow-hidden"}>
        <div className="card-body p-2">
          <h6 className="text-right">{widget.title}</h6>
          <hr className="mt-1 mb-0" />
          {this.renderWidgetContent()}
          {/* <FontAwesomeIcon
            icon={bgIcon}
            className="fa-fw fa-10x text-blend dash-bg-img"
          /> */}
          <div className="dash-pos-bottom px-2">
            <hr className="my-2" />
            <button
              type="button"
              className="btn btn-sm btn-outline-dark float-right mb-2"
              name={`viewDetails_${widget.widgetType}`}
              id={`viewDetails_${widget.widgetType}`}
              onClick={this.handleClick_viewDetails(widget)}
            >
              <FontAwesomeIcon icon="info-circle" className="fa-fw mr-1" />
              View Details
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
});

export default connect(mapStateToProps)(ProjDashWidget);
